// Shared constants for the issue tracking ("Mängel & Störungen") feature:
// priority scale, kanban statuses and their German labels/colors.

export const ISSUE_PRIORITIES = [
  {
    key: 'p1',
    label: 'P1 – Nicht bespielbar',
    shortLabel: 'P1',
    description:
      'Entertainment/Raum fällt komplett aus. Löst sofort die Eskalationskette aus und sperrt den Raum für neue Buchungen.',
    color: '#d32f2f',
  },
  {
    key: 'p2',
    label: 'P2 – Defekt, aber bespielbar',
    shortLabel: 'P2',
    description: 'Etwas ist kaputt, der Spielbetrieb läuft aber weiter.',
    color: '#ef6c00',
  },
  {
    key: 'p3',
    label: 'P3 – Defekt ohne Spielbetriebs-Auswirkung',
    shortLabel: 'P3',
    description: 'Spielrelevantes Element defekt, Gäste merken (noch) nichts. Reparatur nötig.',
    color: '#f9a825',
  },
  {
    key: 'p4',
    label: 'P4 – Irrelevante Deko defekt',
    shortLabel: 'P4',
    description: 'Rein optischer Mangel ohne Relevanz für das Spielerlebnis.',
    color: '#0288d1',
  },
  {
    key: 'p5',
    label: 'P5 – Verbesserungsvorschlag',
    shortLabel: 'P5',
    description: 'Kein Defekt: Idee oder Vorschlag zur Verbesserung.',
    color: '#388e3c',
  },
];

export const ISSUE_PRIORITY_BY_KEY = Object.fromEntries(ISSUE_PRIORITIES.map(p => [p.key, p]));

export const ISSUE_STATUSES = [
  { key: 'open', label: 'Offen', color: '#d32f2f' },
  { key: 'acknowledged', label: 'Reagiert', color: '#f9a825' },
  { key: 'inProgress', label: 'In Arbeit', color: '#0288d1' },
  { key: 'resolved', label: 'Erledigt', color: '#388e3c' },
  { key: 'cancelled', label: 'Verworfen', color: '#757575' },
];

export const ISSUE_STATUS_BY_KEY = Object.fromEntries(ISSUE_STATUSES.map(s => [s.key, s]));

// Kanban columns (cancelled is hidden behind a filter, not a column).
export const KANBAN_STATUSES = ['open', 'acknowledged', 'inProgress', 'resolved'];

export const ESCALATION_STEP_LABELS = {
  executive: 'Geschäftsleitung (Mail)',
  specialtyMatch: 'Spezialgebiet',
  itEmployee: 'IT-Mitarbeiter',
  leadEngineer: 'Lead Engineer',
};

export const ESCALATION_RUN_LABELS = {
  running: 'Läuft',
  acknowledged: 'Reagiert',
  exhausted: 'Ohne Reaktion durchgelaufen',
  cancelled: 'Abgebrochen',
};

// Format a millisecond duration as a compact German string (e.g. "2 Std 15 Min").
export const formatDurationMs = ms => {
  if (!Number.isFinite(ms) || ms < 0) return '–';
  const minutes = Math.round(ms / 60000);
  if (minutes < 1) return '< 1 Min';
  if (minutes < 60) return `${minutes} Min`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours} Std ${minutes % 60} Min`;
  const days = Math.floor(hours / 24);
  return `${days} T ${hours % 24} Std`;
};
